import { useEffect } from "react"
import { getHistoryAdminAllData } from "../../store/actions/monitoring.action"
import { useAppDispatch, useAppSelector } from "../../store/hook/store.hook"
import { historyAdminChangePagination } from "../../store/slices/monitoring/monitoring.slice"


const useAdminHistoryMonitoring = () => {

    const dispatch = useAppDispatch()
    const { admin: { allData, pagination, meta }, loading } = useAppSelector(state => state.monitoring)

    const visitedAllData = () => {
        dispatch(getHistoryAdminAllData({
            pagination
        }))
    }

    useEffect(() => {
        visitedAllData()
    }, [])

    const changePagination = (page: number, limit: number) => {
        dispatch(historyAdminChangePagination({
            limit,
            page
        }))
    }

    return {
        visitedAllData,
        allData,
        pagination,
        meta,
        loading,
        changePagination
    }
}


export default useAdminHistoryMonitoring